import { render } from "./ControlAuditList.vue?vue&type=template&id=406fd31c"
import script from "./ControlAuditList.vue?vue&type=script&lang=js"
export * from "./ControlAuditList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__